import type { ItemType } from "@/modules/compute/vmCreateViewModel.tsx";
import { Trans } from "@lingui/react/macro";

export const description_sshKey = (
    <Trans>
        Public key part of the SSH key pair for logging in to the VM. Must be in format{" "}
        <code>ssh-key-type base64encoded...key optional_comment</code>.
    </Trans>
);

export const t_uefiWarning = <Trans>UEFI variables (NVRAM) will not persist across reboots.</Trans>;

/** Shared by the snapshot sections of both the VM and the disk view. */
export const description_snapshots = (
    // TODO: Use some "Prose" component/style?
    <div className="VStack gap-2">
        <p>
            <Trans>
                Take a snapshot to create an instant image of your virtual machine's current state. You can later use
                the snapshot to restore your virtual machine state or create a new virtual machine from the snapshot
                with modified size parameters.
            </Trans>
        </p>
        <p>
            <Trans>For the snapshots you will only pay for the storage used by the snapshot.</Trans>
        </p>
    </div>
);

export const reinstallTypes: ItemType[] = [
    {
        id: "plain_os",
        title: <Trans>Operating system</Trans>,
        icon: "jp-virtual-machine-icon",
        description: undefined,
    },
    {
        id: "app_catalog",
        title: <Trans>App catalog</Trans>,
        icon: "i-lucide:blocks",
        description: undefined,
    },
];
